"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CadstromMultiMutex = void 0;
const cadstrom_mutex_base_1 = require("./cadstrom-mutex-base");
class CadstromMultiMutex extends cadstrom_mutex_base_1.CadstromMutexBase {
    constructor(mutexes, identifier = mutexes.map((m) => m.identifier).join('|')) {
        super();
        this.mutexes = mutexes;
        this.identifier = identifier;
        if (mutexes.length === 0) {
            throw new Error('CadstromMultiMutex requires at least one mutex');
        }
    }
    get isAcquired() {
        return this.mutexes.every((mutex) => mutex.isAcquired);
    }
    stopRefresh() {
        for (const mutex of this.mutexes) {
            mutex.stopRefresh();
        }
    }
    async acquire() {
        const acquiredMutexes = [];
        try {
            for (const mutex of this.mutexes) {
                await mutex.acquire();
                acquiredMutexes.push(mutex);
            }
        }
        catch (error) {
            await this.releaseSpecificMutexes(acquiredMutexes);
            throw error;
        }
    }
    async tryAcquire() {
        const acquiredMutexes = [];
        try {
            for (const mutex of this.mutexes) {
                const acquired = await mutex.tryAcquire();
                if (!acquired) {
                    await this.releaseSpecificMutexes(acquiredMutexes);
                    return false;
                }
                acquiredMutexes.push(mutex);
            }
            return true;
        }
        catch (error) {
            await this.releaseSpecificMutexes(acquiredMutexes);
            return false;
        }
    }
    async release() {
        await this.releaseSpecificMutexes([...this.mutexes].reverse());
    }
    async releaseSpecificMutexes(mutexesToRelease) {
        for (const mutex of mutexesToRelease) {
            try {
                await mutex.release();
            }
            catch (error) {
                console.error(`Failed to release mutex ${mutex.identifier}:`, error);
            }
        }
    }
}
exports.CadstromMultiMutex = CadstromMultiMutex;
//# sourceMappingURL=cadstrom-multi-mutex.js.map